import type { BannerWidgetRepository } from '../../domain/interfaces/BannerWidgetRepository';
import type { BannerWidget } from '../../domain/models/BannerWidget';
import { type BannerWidgetVm, toBannerWidgetVm } from '../viewModels/bannerWidget.app.vm';

export type BannerWidgetService = ReturnType<typeof createBannerWidgetService>;

export function createBannerWidgetService(repo: BannerWidgetRepository) {
  return {
    /**
     * Returns application-level ViewModels (plain objects), not domain classes.
     * Presentation layer should depend on this shape.
     */
    async getWidgetBanners(tags?: string): Promise<BannerWidgetVm[]> {
      const domainBanners: BannerWidget[] = await repo.fetchWidgetBanners({ tags });
      return domainBanners.map(toBannerWidgetVm);
    },
    async getBrowseBanners(tags?: string): Promise<BannerWidgetVm[]> {
      const domainBanners: BannerWidget[] = await repo.fetchBrowseBanners({ tags });
      return domainBanners.map(toBannerWidgetVm);
    },
  };
}


